import { React } from 'react';
import { Login } from '@indigenux/design/views';

import logo from 'img/indi-logo-dark.svg';

const LoginView = () => {
    return (<Login logo={logo}></Login>);
};

export default LoginView;